import * as React from 'react';
export const dinersSvg = React.forwardRef(function dinersSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        fillRule: 'nonzero',
        d: 'M1 12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E6EBF1',
        fillRule: 'nonzero',
        d: 'M1 12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8Zm-1 0V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#0069AA',
        d: 'M7 4h2a4 4 0 1 1 0 8H7a4 4 0 1 1 0-8Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        fillRule: 'nonzero',
        d: 'M7 10.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm0 1a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M6.25 5h1.5v6h-1.5z',
      }),
    ),
  );
});
dinersSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var diners = {
  category: 'card',
  colorable: false,
  name: 'diners',
  svg: dinersSvg,
};
